<template>
  <!--  产品中心 -->
  <div class="">
    <HeaderTop />
    <MenuPage />

    <BannerDetail
      :backgroundImage="require('../assets/img/banner5.jpg')"
      :title="$t('product1')"
      :description="$t('product2')"
    />

    <div class="product-main">
      <div class="product-box">
        <div class="product-left">
          <div class="menu-box bgred">{{$t('products')}}</div>
          <div class="menu-main">
            <div
              class="menu-box"
              @click="activeTab = '不干胶标签'"
              :class="{ active: activeTab === '不干胶标签' }"
            >
              {{$t('adhesiveLabels')}}
            </div>
            <div
              class="menu-box"
              @click="activeTab = '柔性抗金属标签'"
              :class="{ active: activeTab === '柔性抗金属标签' }"
            >
               {{$t('flexibleMetalLabels')}}
            </div>
            <div
              class="menu-box"
              @click="activeTab = '抗金属标签'"
              :class="{ active: activeTab === '抗金属标签' }"
            >
                 {{$t('antiMetalLabels')}}
            </div>
            <div
              class="menu-box"
              @click="activeTab = '洗涤标签'"
              :class="{ active: activeTab === '洗涤标签' }"
            >
               {{$t('washingLabels')}}
            </div>
            <div
              class="menu-box"
              @click="activeTab = '吊牌'"
              :class="{ active: activeTab === '吊牌' }"
            >
              {{$t('hangtags')}}
            </div>
            <div
              class="menu-box"
              @click="activeTab = '动物耳标'"
              :class="{ active: activeTab === '动物耳标' }"
            >
               {{$t('animalEarTags')}}
            </div>
            <div
              class="menu-box"
              @click="activeTab = '腕带'"
              :class="{ active: activeTab === '腕带' }"
            >
               {{$t('wristbands')}}
            </div>
          </div>
        </div>

        <div class="product-right">
          <div v-if="activeTab === '不干胶标签'">
            <div class="product-title"><span class="iconfont icon-biaotishutiao"></span> {{$t('adhesiveLabels')}}</div>
              <ProductItemone   />
          </div>
          <div v-if="activeTab === '柔性抗金属标签'">
             <div class="product-title"><span class="iconfont icon-biaotishutiao"></span> {{$t('flexibleMetalLabels')}}</div>
             <ProductItemtwo />
          </div>
          <div v-if="activeTab === '抗金属标签'">
             <div class="product-title"><span class="iconfont icon-biaotishutiao"></span> {{$t('antiMetalLabels')}}</div>
           <ProductItemthree />
          </div>
          <div v-if="activeTab === '洗涤标签'">
             <div class="product-title"><span class="iconfont icon-biaotishutiao"></span> {{$t('washingLabels')}}</div>
             <ProductItemfour/>
           
          </div>
          <div v-if="activeTab === '吊牌'">
             <div class="product-title"><span class="iconfont icon-biaotishutiao"></span>  {{$t('hangtags')}}</div>
             <ProductItemfive/>
          </div>
          <div v-if="activeTab === '动物耳标'">
             <div class="product-title"><span class="iconfont icon-biaotishutiao"></span>  {{$t('animalEarTags')}}</div>
 <ProductItemsix/>
          </div>
          <div v-if="activeTab === '腕带'">
          <div class="product-title"><span class="iconfont icon-biaotishutiao"></span> {{$t('wristbands')}}</div>
          <ProductItemseven/>
              
          </div>
        </div>
      </div>
    </div>

    <div class="footer-main">
      {{ $t("footertitile") }}
    </div>
  </div>
</template>

<script>
import MenuPage from "../components/MenuPage.vue";
import HeaderTop from "../components/HeaderTop.vue";
import BannerDetail from "@/components/BannerDetail.vue";
import ProductItemone from '@/components/ProductItemone.vue';
import ProductItemtwo from '@/components/ProductItemtwo.vue';
import ProductItemfour from '@/components/ProductItemfour.vue';
import ProductItemfive from '@/components/ProductItemfive.vue';
import ProductItemsix from '@/components/ProductItemsix.vue';
import ProductItemseven from '@/components/ProductItemseven.vue';
import ProductItemthree from '@/components/ProductItemthree.vue';

export default {
  components: { HeaderTop, MenuPage, BannerDetail, ProductItemone,ProductItemtwo,ProductItemfour,ProductItemfive,ProductItemsix,ProductItemseven, ProductItemthree},
  name: "NewsPage",
  mounted() {
    this.scrollToTop();
  },
  data() {
    return {
      activeTab: "不干胶标签",
    };
  },
  methods: {
     scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>
<style scoped>
.product-main {
  float: left;
  width: 100%;
  background: #f6f6f6;
  padding-bottom: 50px;
}

.product-box {
  width: 1200px;
  margin: 0 auto;
}
.product-left {
  float: left;
  width: 18%;
  background: #fff;
  border: 1px solid #eee;
  box-sizing: border-box;
  margin-top: 20px;
}
.menu-box {
  padding: 12px 20px;
  box-sizing: border-box;
  border-bottom: 1px solid #eee;
  font-size: 16px;
  color: #4a4a4a;
  cursor: pointer;
}
.icon-biaotishutiao{
   color: #d1261e;
}
.product-title{
 font-size: 20px;
  color: #4a4a4a;
  font-weight: 800;
  margin-bottom: 10px;
}
.bgred {
  background: #d1261e;
  color: #fff;
}
.menu-box.active {
  background-color: #f5e6e7;
  color: #d1261e;
}

.product-right {
  float: right;
  width: 80%;
   background: #fff;
  border: 1px solid #eee;
  box-sizing: border-box;
  margin-top: 20px;
  padding: 20px ;
  box-sizing: border-box;
  min-height: 800px;
}


@media (max-width: 1200px) {
  .product-box {
  float: left;
    width: 100%;
}
  .product-left {
    float: left;
    width: 100%;
  
  }
  .product-right {
    float: left;
    width: 100%;
  
  }
}
</style>
